import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./HealthBenefits.css";

const cards = [
  {
    icon: <img src="/icons/robot.webp" alt="Efficiency" />,
    title: "PRODUCTION PLANNING AND SCHEDULING",
    desc: "Use advanced software to optimize production schedules, resource allocation, and material flow for enhanced efficiency and reduced lead times."
  },
  {
    icon: <img src="/icons/computer.webp" alt="Sustainability" />,
    title: "SUPPLY CHAIN VISIBILITY AND COLLABORATION",
    desc: "Cloud-based platforms facilitate real-time communication and collaboration with suppliers, enabling informed purchasing decisions and timely material deliveries."
  },
  
  {
    icon: <img src="/icons/human.webp" alt="Engagement" />,
    title: "AUTOMATED QUALITY CONTROL AND INSPECTION",
    desc: "Implement machine vision systems, AI-powered defect detection, and automated inspection tools to ensure consistent product quality and early identification of potential issues."
  },
   {
    icon: <img src="/icons/human.webp" alt="Engagement" />,
    title: "PREDICTIVE MAINTANENCE AND CONDITION MONITORING",
    desc: "Sensor-based monitoring and data analytics empower proactive maintenance strategies, preventing equipment failures, and extending asset lifespan."
  }
];

export default function GreenBenefits({ imageSrc }) {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  return (
    <section className="green-benefits-section" id="benefits">
      <div className="green-benefits-top">
        <div className="green-benefits-text" data-aos="fade-right">
          <div className="green-benefits-title">
            DIGITAL ACCELERATION<br />
            <span className="green-benefits-title-blue">IN MANUFACTURING</span>
          </div>
          <div className="green-benefits-desc">
            Whether you are focused on management and planning software or quality control and supply chain management software, our solutions provide comprehensive tools to meet your specific needs. Unlock the potential of technology and embrace digital transformation in the Manufacturing industry.
          </div>
        </div>
        <div className="green-benefits-image" data-aos="fade-left">
          <img src={imageSrc} alt="Digital Acceleration" />
        </div>
      </div>
      <div className="green-benefits-cards">
        {cards.map((card, i) => (
          <div
            className="green-benefits-card"
            key={i}
            data-aos="fade-up"
            data-aos-delay={100 + i * 100}
          >
            <div className="green-benefits-card-icon">{card.icon}</div>
            <div className="green-benefits-card-title">{card.title}</div>
            <div className="green-benefits-card-desc">{card.desc}</div>
          </div>
        ))}
      </div>
      <div className="green-benefits-btn-row" data-aos="fade-up" data-aos-delay="500">
        <button className="green-benefits-btn">
          MORE ABOUT DIGITAL ACCELERATION
        </button>
      </div>
    </section>
  );
}